import { render, staticRenderFns } from "./Dropdown.vue?vue&type=template&id=3ef86649&scoped=true&"
import script from "./Dropdown.vue?vue&type=script&lang=ts&"
export * from "./Dropdown.vue?vue&type=script&lang=ts&"
import style0 from "./Dropdown.vue?vue&type=style&index=0&id=3ef86649&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef86649",
  null
  
)

export default component.exports
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QInput});
